import React from 'react';
import Asterisk from './Asterisk';

const DoubledAsterisk = () => (
  <>
    <Asterisk />
    <Asterisk />
  </>
);

export default DoubledAsterisk;
